import React from "react";
import { Link } from "gatsby";

import {
  EuiTitle,
  EuiSpacer,
  EuiFlexGroup,
  EuiFlexItem,
  EuiHorizontalRule,
  EuiHideFor,
} from "@elastic/eui";

import IntroCards from "./IntroInternetToC";
import IntroCardsMobile from "./IntroInternetToC_mobile";

export default function IntroHome() {
  return (
    <React.Fragment>
      <EuiSpacer />
      <EuiTitle size="m">
        <h2>DDNS & P2P</h2>
      </EuiTitle>
      <EuiTitle size="s">
        <h4>
          Verwenden Sie den P2P- oder DDNS-Dienst Ihrer Kamera, um über das
          Internet auf sie zuzugreifen
        </h4>
      </EuiTitle>
      <div>
        <ul>
          <li>
            <Link to="/Web_User_Interface/1440p_Serie/Netzwerk/IP_Konfiguration/#ipv6-port-weiterleitung">
              IPv6 Port Weiterleitung (für UHD Kameramodelle)
            </Link>
          </li>
          <li>
            <Link to="/Schnell_Installation/Internet_Protocol_IPv6/">
              Was ist IPv6 und wie funktioniert SLAAC?
            </Link>
          </li>
          <li>
            <Link to="/Frequently_Asked_Question/WQHD_IPv6_Portforwarding/">
              Anleitung zur IPv6 Portfreischaltung in einer AVM Fritzbox
            </Link>
          </li>
        </ul>
      </div>
      <EuiHorizontalRule margin="xs" />
      <EuiFlexGroup
        gutterSize="l"
        direction="column"
        style={{ margin: "0 7px" }}
      >
        <EuiFlexItem>
          <EuiHideFor sizes={["xs", "s", "m", "l"]}>
            <IntroCards />
          </EuiHideFor>
          <EuiHideFor sizes={["xl"]}>
            <IntroCardsMobile />
          </EuiHideFor>
        </EuiFlexItem>
      </EuiFlexGroup>
    </React.Fragment>
  );
}
